// TODO: Set lint error when using import.meta.env directly when Biome 2 plugin is released
import { z } from "zod";

export const env = z
  .object({
    VITE_APP_ENV: z.enum(["development", "staging", "production"]).default("development"),
    VITE_API_BASE: z.string(),
    VITE_SUPABASE_URL: z.string().url(),
    VITE_SUPABASE_KEY: z.string(),
    VITE_SENTRY_DSN: z.string().url(),
    VITE_PIXEL_ID: z.string(),
    VITE_GOOGLE_OAUTH_WEB_CLIENT_ID: z.string(),
    VITE_MIXPANEL_TOKEN: z.string(),
    VITE_PAYPAL_CLIENT_ID: z.string(),
    VITE_PROXY_API_BASE: z.string(),
    VITE_TIKTOK_CLIENT_KEY: z.string(),
  })
  .transform((env) => ({
    API_BASE: env.VITE_API_BASE,
    APP_ENV: env.VITE_APP_ENV,
    SUPABASE_URL: env.VITE_SUPABASE_URL,
    SUPABASE_KEY: env.VITE_SUPABASE_KEY,
    SENTRY_DSN: env.VITE_SENTRY_DSN,
    PIXEL_ID: env.VITE_PIXEL_ID,
    GOOGLE_OAUTH_WEB_CLIENT_ID: env.VITE_GOOGLE_OAUTH_WEB_CLIENT_ID,
    MIXPANEL_TOKEN: env.VITE_MIXPANEL_TOKEN,
    PAYPAL_CLIENT_ID: env.VITE_PAYPAL_CLIENT_ID,
    PROXY_API_BASE: env.VITE_PROXY_API_BASE,
    TIKTOK_CLIENT_KEY: env.VITE_TIKTOK_CLIENT_KEY,
  }))
  .parse(import.meta.env);
